<mat-form-field class="json-input">
  <mat-label>{{ label }}</mat-label>
  <textarea matInput
    [ngClass]="{'is-invalid': hasError}"
    rows="8"
    [value]="value"
    (input)="onInputChange($event)"
    (blur)="onBlur()"
    [matTooltip]="tooltip"
    matTooltipPosition="right"
    matTooltipClass="multiline-tooltip"
  placeholder="Enter JSON configuration"></textarea>
  @if (hasError) {
    <div class="invalid-feedback">
      {{ errorMessage }}
    </div>
  }
</mat-form-field>
